import { Component, OnInit } from '@angular/core';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';

@Component({
    standalone: false,
    selector: 'particle-task-manager-my-ticket-list',
  templateUrl: './task-manager-my-ticket-list.component.html',
  styleUrls: ['./task-manager-my-ticket-list.component.scss']
})
export class TaskManagerMyTicketListComponent implements OnInit {
  invalidateSubject: InvalidateSubject;
  sourceKey: string;
  breadcrumbs: BreadcrumbModel[];
  constructor() {
    this.invalidateSubject = new InvalidateSubject();
    this.sourceKey = 'MyTasks';
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id: 'TaskManager',
        title: 'Task Manager',
        relativeUrl: 'task-manager/card',
        type: 'Repository'
      },
      <BreadcrumbModel>{
        id: 'MyTickets',
        title: 'My Tickets',
        relativeUrl: 'task-manager/my-tickets',
        type: 'Repository'
      }
    ];
  }

  ngOnInit() {
  }
  onGridCellValueChange(event) {

  }

  addTask() {

  }
}
